<template>
  <v-app>
    <!--<v-app-bar
      app
      color="#35495E"
      dark
    >
      <div class="d-flex align-center">
        <span>Hajime Shoji</span>
      </div>

      <v-spacer></v-spacer>

      <router-link to="/about">CONTACT</router-link>
    </v-app-bar>-->
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    //HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
